if(window.location.hash) scroll(0,0);
setTimeout(function() { scroll(0,0); }, 1);

const isTouchDevice = 'ontouchstart' in document.documentElement;
const mq = {
  mobile: 'screen and (max-width:767px)'
};

(function($, Drupal){
  if ($('.homepage-header--slides--wrap').length) {
    let paginations = [];
    let label = [];
    const icons = $('.homepage-header--slide .field_icon');
    $('.homepage-header--slide .field_icon').each(function(index) {
      paginations.push($(this).html());
    });
    $('.homepage-header--slide .field_label').each(function(index) {
      label.push($(this).text().replace('&', '<span>&</span>'));
    });
    var mySwiper = new Swiper ('.swiper-container', {
      loop: true,
      slidesPerView: 1,
      centeredSlides: true,
      effect: 'fade',
      speed: 1000,
      autoplay: {
        delay: 3000,
      },
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className
                + '"><div class="swiper-pagination-bullet--icon">' + (paginations[index]) + '</div>'
                + '<div class="swiper-pagination-bullet--label"><h2>'+ (label[index]) + '</h2></div></span>';
        }
      },
    });
  }

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 200) {
      $('#return-to-top').addClass('to-up');
    } else {
      $('#return-to-top').removeClass('to-up');
    }
  });
  $('#return-to-top').on('touchstart click', function() {
    if ($(this).hasClass('to-up')) {
      $('body,html').animate({
        scrollTop : 0
      }, 500);
    }
    else {
      $('body, html').animate({
        scrollTop : $('main').offset().top
      }, 500);
    }
  });

  $(document).ready(function() {
    const sitemap = $('.sitemap');
    if (sitemap.length) {
      $('.sitemap-box-menu > .content > .sitemap-menu > li').addClass('active');
      $('.sitemap-box-menu > .content > .sitemap-menu > li > ul').before('<div class="sitemap-menu--trigger"><span class="sitemap-menu--trigger--icon"></span></div>');
      $('.sitemap-menu--trigger').click(function() {
        $(this).parent().toggleClass('active');
      });
    }
    $('#search-block-form').submit(function(event){
      const keywords = $('#edit-keys').val();
      if (keywords) {
        window.location.replace('/suche-allgemein?text=' + keywords);
      }
      event.preventDefault();
    });
    $('.search--exposed-form .form-select').niceSelect();
    FastClick.attach(document.body);
    $('.nav--menu-trigger').on('touchstart', function() {
      $(this).toggleClass('is-active');
      $('.nav .container__content').toggleClass('active');
    });
    let mainMenu = false;
    enquire.register(mq['mobile'], {
      match : function() {
        if (!mainMenu) {
          mainMenu = $('#block-ifak-main-menu').slideMenu({
            submenuLinkAfter: '',
            showBackLink: true
          });
        }
        else {
          mainMenu.close();
        }
      },
      unmatch : function() {
        if (mainMenu) {
          mainMenu.close();
        }
      },
    });
    const search = $('.nav #block-ifak-search-form');
    if (search.length) {
      $('.nav .search-block-form--trigger').on('click', function() {
        search.toggleClass('active');
        $('#block-ifak-main-menu').toggleClass('search-active');
      });
      /*
      const search_placeholder = $('#edit-keys').attr('placeholder');
      const blinker = function() {
        if ($('#edit-keys').attr('placeholder')) {
          $('#edit-keys').attr('placeholder', '');
        } else {
          $('#edit-keys').attr('placeholder', search_placeholder);
        }
        setTimeout(blinker, 1000);
      }
      blinker();
      */
    }
    $('.custom-accordion').accordion({
      heightStyle: 'content',
      collapsible: true,
      active: false
    });
  });

  Drupal.behaviors.ajaxExposedForm = {
    attach: function(context, settings) {
      $('.search--exposed-form--ajax').each(function(index) {
        const sort = $(this).find('select[name="sort_bef_combine"]');
        if (sort.is(':visible')) {
          sort.niceSelect();
        }
      });
    }
  };

})(jQuery, Drupal);
